import React, { useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import componentFunctions from '../../../../services/tools/componentFunctions';

import css from './RequestTable.module.css'

function RequestTable ({data}) {
    const [filter, setFilter] = useState('');
    const [showEnrolled, setShowEnrolled] = useState(true);
    const [showCancelled, setShowCancelled] = useState(true);
    const [showCompleted, setShowCompleted] = useState(true);
    // const [showClosed, setShowClosed] = useState(true);
    const [sortConfig, setSortConfig] = useState(componentFunctions.sortConfig);
    const requestSort = (key) => componentFunctions.requestSort(key, sortConfig, setSortConfig);
    const navigate = useNavigate();

    const sortedAndFilteredData = useMemo(() => {
        // let returnedData = componentFunctions.sortedAndFilteredData(data, sortConfig, filter);

        // returnedData.filter((x) => (showClosed ? x.Status !== 'Closed' : true));
        // returnedData.filter((x) => (showCancelled ? x.Status !== 'Closed' : true));

        return componentFunctions.sortedAndFilteredData(data, sortConfig, filter)
            .filter((x) => (showEnrolled ? x.Status !== 'Enrolled' : true))
            .filter((x) => (showCancelled ? x.Status !== 'Cancelled' : true))
            .filter((x) => (showCompleted ? x.Status !== 'Completed' : true));
    }, [data, sortConfig, filter, showEnrolled, showCancelled, showCompleted]);

    if (!data || !data.length) {
        return <p>No data available.</p>;
    }
    
    
    const headers = Object.keys(data[0]);

    const handleShowEnrolledFilter = () => {
        setShowEnrolled((state) => !state);
    };
    const handleShowCancelledFilter = () => {
        setShowCancelled((state) => !state);
    };
    const handleShowCompletedFilter = () => {
        setShowCompleted((state) => !state);
    };

    // console.log(caller);

    return (
        <>
            <div className={css.control}>
                <input
                    type="text"
                    placeholder="Filter results..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className={css.filterInput}
                    //box-shadow: 0 0 8px 0 #54b5f7;
                    // style={{color: isError ? "red" : "black"}}
                />
                <div className={sortedAndFilteredData.length === 0 ? `${css.filterCount} ${css.filterCountZero}` : css.filterCount}>
                    {' '}
                    {sortedAndFilteredData.length}{' '}
                </div>
            </div>
            <div style={{ textAlign: 'right', marginTop: '5px', color: 'red', fontSize: '1.2rem' }}>
                <label>
                    Show Enrolled?
                    <input type="checkbox" onChange={handleShowEnrolledFilter} value={showEnrolled} />
                </label>
                <label>
                    Show Cancelled?
                    <input type="checkbox" onChange={handleShowCancelledFilter} value={showCancelled} />
                </label>
                <label>
                    Show Completed?
                    <input type="checkbox" onChange={handleShowCompletedFilter} value={showCompleted} />
                </label>
            </div>
            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        {headers.map((header) => (
                            <th key={header} onClick={() => requestSort(header)} className={css.th} style={{ cursor: 'pointer' }}>
                                {header}
                                {sortConfig.key === header ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className={css.tbody}>
                    {sortedAndFilteredData.length > 0 ? (
                        sortedAndFilteredData.map((item, index) => (
                            <tr
                                key={item[Object.keys(item)[0]]}
                                id={item[Object.keys(item)[0]]}
                                onClick={() => navigate('/student/details/' + item.StudentID)}
                                className={css.row}
                            >
                                {headers.map((header, headerIndex) => (
                                    <td
                                        key={headerIndex}
                                        className={['DoB', 'Date', 'Start', 'End'].includes(header) ? css.tdWide : css.td}
                                        style={item[header] === '01-Jan-1900' ? {color: 'red'} : {}}
                                    >
                                        {header === 'L' ? (
                                            <Link to={item[header]} target="_blank" rel="noopener noreferrer">
                                                <i className="fa-regular fa-file-lines"></i>{' '}
                                            </Link>
                                        ) : (
                                            item[header]
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                                No matching records found. Please adjust your filter.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
}

export default RequestTable;